<template>
	<div class="sheet">
		<div class="sheet-item" v-for="(item, index) in options" :key="index" @click="handleClick(index, current)">
			<div :class="['sheet-item-text', current === index ? 'active' : '']">{{ item }}</div>
			<div class="sheet-item-line">
				<div class="sheet-item-line-content" v-if="current === index"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			current: {
				type: Number,
				default: 1
			},
			options: {
				type: Array,
				default: () => []
			}
		},
		methods: {
			handleClick(index, current) {
				if (index !== current) {
					this.$emit('update:current', index)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.sheet {
		height: 82px;
		background-color: $color-white;
		@extend .flex-row;

		&-item {
			flex: 1;
			height: 82px;
			@extend .flex-row-center;
			@include relative;

			&-text {
				@include text(28px, 400, rgba(0, 0, 0, 0.9));

				&.active {
					// color: $color-primary;
				}
			}

			&-line {
				position: absolute;
				bottom: 16px;
				left: 0;
				right: 0;
				height: 12px;
				@extend .flex-row-center;

				&-content {
					width: 80px;
					height: 12px;
					background: linear-gradient(90deg, #FF9A72 0%, rgba(255, 154, 114, 0) 100%);
					border-radius: 14px;
				}
			}
		}
	}
</style>
